import { getConfig, setConfig } from '@/api/system/config'
import { Message, Loading } from 'element-ui'

const state = {
  config: {}
}

const mutations = {
  UPDATE_CONFIG: (state, config) => {
    state.config = JSON.parse(JSON.stringify(config))
  }
}

let message

const actions = {
  // 加载配置参数
  async loadConfig({ commit }) {
    const data = await getConfig()
    const config = {}
    data.data.forEach(it => {
      config[`${it.type}.${it.name}`] = it.value
    })
    commit('UPDATE_CONFIG', config)
    console.log(config)
  },
  // 更新配置参数
  async updateConfig({ dispatch }, { type, name, value }) {
    const loading = Loading.service({
      lock: true,
      text: '请稍候...',
    })
    try {
      await setConfig(type, name, value)
      console.log(await dispatch('loadConfig'))
      message?.close()
      message = Message({
        message: '参数已更新',
        type: 'success'
      })
    } finally {
      loading.close()
    }
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
